import { render, staticRenderFns } from "./LastCall.vue?vue&type=template&id=25b751e4&scoped=true"
import script from "./LastCall.vue?vue&type=script&lang=js"
export * from "./LastCall.vue?vue&type=script&lang=js"
import style0 from "./LastCall.vue?vue&type=style&index=0&id=25b751e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b751e4",
  null
  
)

export default component.exports